<template>
  <div>
    <ScreenMotto/>
    <ScreenAbout/>
    <ScreenDigits/>
    <ScreenBanner/>
    <ScreenServices/>
    <ScreenPortfolio/>
    <ScreenTech/>
    <ScreenContacts/>
    <contact-modal-form></contact-modal-form>
  </div>
</template>

<style lang="scss">
body {
  min-width: 320px;
}
</style>

<script>
import ScreenMotto from "../components/ScreenMotto";
import ScreenAbout from "../components/ScreenAbout";
import ScreenDigits from "../components/ScreenDigits";
import ScreenBanner from "../components/ScreenBanner";
import ScreenServices from "../components/ScreenServices";
import ScreenTech from "../components/ScreenTech";
import ScreenContacts from "../components/ScreenContacts";
import ScreenPortfolio from "../components/ScreenPortfolio";
import ContactModalForm from "@/components/common/ContactModalForm";

export default {
  components: {
    ContactModalForm,
    ScreenMotto,
    ScreenAbout,
    ScreenDigits,
    ScreenBanner,
    ScreenServices,
    ScreenPortfolio,
    ScreenTech,
    ScreenContacts,
  },
  metaInfo() {
    return {
      title: `Gemark`,
      meta: [
        {
          name: 'description',
          content: `Gemark`
        },
      ]
    }
  },
}
</script>